import React from "react";
import Checkmark from "../../../images/Checkmark.png";

const LanguageSupportTable = () => {
  const tableHeaders = [
    "LANGUAGES",
    "TEXT-TO-TEXT",
    "TEXT-TO-SPEECH",
    "SPEECH-TO-TEXT",
  ];
  const languages = ["English", "Yoruba", "Swahili", "Nigerian pidgin"];

  return (
    <div className="w-full overflow-x-auto">
      <table className="w-full border border-[#cbd1ce] border-collapse">
        <thead>
          <tr className="border border-[#cbd1ce]">
            {tableHeaders.map((header, index) => (
              <th
                key={index}
                className="py-4 px-6 text-center font-black text-base tracking-wider border border-[#cbd1ce]"
                style={{ fontFamily: "Axiforma", letterSpacing: "0.8px" }}
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {languages.map((language, langIndex) => (
            <tr key={langIndex} className="border border-[#cbd1ce]">
              <td
                className="py-4 px-6 text-center font-bold text-base border border-[#cbd1ce]"
                style={{
                  fontFamily: "Axiforma",
                  letterSpacing: "0.8px",
                  color: "#10281e",
                }}
              >
                {language}
              </td>
              {[1, 2, 3].map((colIndex) => (
                <td
                  key={colIndex}
                  className="py-4 px-6 text-center border border-[#cbd1ce]"
                >
                  <img
                    src={Checkmark}
                    alt="checkmark"
                    className="inline-block w-5 h-5"
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default LanguageSupportTable;
